export const addZeroes = (num) => {
    // Cast as number
    var num = Number(num);
    // If not a number, return 0
    if (isNaN(num)) {
        return 0;
    }
    // If there is no decimal, or the decimal is less than 2 digits, toFixed
    if (String(num).split(".").length < 2 || String(num).split(".")[1].length <= 2) {
        num = num.toFixed(2);
    }
    // Return the number
    return num;
}

export const capitalizeWords = (str) => {
    return str
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const getRateTrend = (newAmount, oldAmount) => {
    if (oldAmount === null || oldAmount === undefined || oldAmount === "") {
        return null;
    }
    const newVal = Number(newAmount);
    const oldVal = Number(oldAmount);
    if (isNaN(newVal) || isNaN(oldVal)) {
        return null;
    }
    if (newVal > oldVal) return "up";
    if (newVal < oldVal) return "down";
    return null;
};

export const getRateChangePercent = (newAmount, oldAmount) => {
    if (oldAmount === null || oldAmount === undefined || oldAmount === "") {
        return null;
    }
    const newVal = Number(newAmount);
    const oldVal = Number(oldAmount);
    if (isNaN(newVal) || isNaN(oldVal) || oldVal === 0) {
        return null;
    }
    const percent = Math.abs(((newVal - oldVal) / oldVal) * 100);
    return percent.toFixed(2);
};